import React from 'react';
import { AnalyticsProvider, AnalyticsTrigger, Anchor, Banner, BannerHeading, BannerItem, Button, Card, CardBottom, CardContent, CardFooter, CardHeader, CardTop, Collapse, CollapseLayer, CollapseLayerGrid, CollapseLayerProvider, CollapseProvider, CollapseToggle, CollapseTrigger, Container, EqualHeight, EqualHeightProvider, FeatureList, FeatureListItem, Fittext, Grid, GridCollapse, GridCollapseProvider, GridCollapseTrigger, GridColumn, HashTrigger, Heading, Icon, Image, List, ListItem, Modal, ModalCloser, ModalProvider, ModalTrigger, Notice, ObjectFit, Pebble, Section, SectionImage, Separator, Tag, Text, Tooltip, TooltipToggle, UserAgent, Video, } from 'telia-front-react';
import ErrorUtil from '../../../util/ErrorUtil';
import ExtendedJsxParser from './ExtendedJsxParser';
import { TranslationsContext } from '@teliaee/telia-translate';
class JsxRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.componentDidUpdate = (prevProps) => {
            if (this.props.jsx !== prevProps.jsx && this.state.errored) {
                this.setState({ errored: false });
            }
        };
        this.renderError = () => {
            const translate = this.context.translate;
            return (React.createElement(Container, null,
                React.createElement(Separator, { spacing: "large", color: "invisible" }),
                React.createElement(Notice, { type: "error" }, translate('general.error.message')),
                React.createElement(Separator, { spacing: "large", color: "invisible" })));
        };
        this.handleError = (e) => {
            this.setState({ errored: true });
            const jsxError = new Error(`JSX render failed on ${window.location.pathname}`);
            jsxError.stack = e.stack;
            ErrorUtil.pushErrorToTeliaRumAndLog(jsxError);
        };
        this.state = { errored: false };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.jsx !== this.props.jsx || this.state.errored !== nextState.errored;
    }
    render() {
        if (this.state.errored && this.props.showErrorNotice) {
            return this.renderError();
        }
        return (React.createElement(ExtendedJsxParser, { components: {
                ...this.props.webComponents,
                AnalyticsProvider,
                AnalyticsTrigger,
                Anchor,
                Banner,
                BannerHeading,
                BannerItem,
                Button,
                Card,
                CardBottom,
                CardContent,
                CardFooter,
                CardHeader,
                CardTop,
                Collapse,
                CollapseLayer,
                CollapseLayerGrid,
                CollapseLayerProvider,
                CollapseProvider,
                CollapseToggle,
                CollapseTrigger,
                Container,
                EqualHeight,
                EqualHeightProvider,
                FeatureList,
                FeatureListItem,
                Fittext,
                Grid,
                GridCollapse,
                GridCollapseProvider,
                GridCollapseTrigger,
                GridColumn,
                HashTrigger,
                Heading,
                Icon,
                Image,
                List,
                ListItem,
                Modal,
                ModalCloser,
                ModalProvider,
                ModalTrigger,
                Notice,
                ObjectFit,
                Pebble,
                Section,
                SectionImage,
                Separator,
                Tag,
                Text,
                Tooltip,
                TooltipToggle,
                UserAgent,
                Video,
            }, onError: this.handleError, showWarnings: this.props.env !== 'live', renderInWrapper: false, renderUnrecognized: (tagName) => this.props.env !== 'live' && React.createElement(Notice, { type: "error" },
                "Unknown component $",
                tagName), ...this.props, jsx: this.props.jsx }));
    }
}
JsxRenderer.contextType = TranslationsContext;
export default JsxRenderer;
